/**
 * フェードインアニメーション（Intersection Observer）
 * - data-fade-in 属性を持つ要素を監視
 * - 画面内に入ったら is-active を付与
 * - data-fade-in-repeat がある場合: 画面外→画面内のたびに再度アニメーション
 * - data-fade-in-repeat がない場合: 初回のみアニメーション（デフォルト）
 */

const ACTIVE_CLASS = "is-active";
const ATTR_FADE_IN = "data-fade-in";
const ATTR_REPEAT = "data-fade-in-repeat";

const DEFAULT_OPTIONS = {
  root: null,
  rootMargin: "0px 0px -10% 0px", // 10% 画面内に入ったら発火
  threshold: 0,
};

/**
 * フェードイン初期化
 */
export function initFadeIn() {
  const elements = document.querySelectorAll(`[${ATTR_FADE_IN}]`);
  if (elements.length === 0) return;

  const onceElements = [];
  const repeatElements = [];

  elements.forEach((el) => {
    if (el.hasAttribute(ATTR_REPEAT)) {
      repeatElements.push(el);
    } else {
      onceElements.push(el);
    }
  });

  if (onceElements.length > 0) {
    createObserver(onceElements, { once: true });
  }

  if (repeatElements.length > 0) {
    createObserver(repeatElements, { once: false });
  }
}

/**
 * Intersection Observer を作成
 * @param {HTMLElement[]} elements - 監視対象要素
 * @param {{ once: boolean }} options - once: true で1回のみ、false で繰り返し
 */
function createObserver(elements, { once }) {
  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      const el = entry.target;

      if (entry.isIntersecting) {
        el.classList.add(ACTIVE_CLASS);
        if (once) {
          observer.unobserve(el);
        }
      } else if (!once) {
        el.classList.remove(ACTIVE_CLASS);
      }
    });
  };

  const observer = new IntersectionObserver(callback, DEFAULT_OPTIONS);

  elements.forEach((el) => observer.observe(el));
}
